import React, { useEffect, useState } from 'react'

export default function ClientOnly({
  children,
}: {
  children: React.ReactNode
}) {
  let [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  return mounted ? <>{children}</> : null
}
